import React, { memo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import { makeStyles } from '@material-ui/core/styles';
import fontSizeOptions from '../../../../../constants/fontSizeOptions';
import PageContext from '../../../../../contexts/PageContext';
import { formatDateMMMYYYY, safetyCheck } from '../../../../../utils';
import { RightHeading } from '../../containers/HeadingModifiers';

const useStyles = makeStyles({
  root: {
    fontSize: (props) => props,
  },
});

const EducationItem = ({ item, language, fontSize }) => {
  const { t } = useTranslation();
  const classes = useStyles({
    fontSize: fontSizeOptions['text-base'] + fontSize,
  });
  return (
    <div>
      <div className="flex flex-row">
        <div className="w-1/6">
          {item.startDate && (
            <h6
              className="font-medium"
              style={{
                fontSize: fontSizeOptions['text-base'] + fontSize,
              }}
            >
              {formatDateMMMYYYY(
                {
                  date: item.startDate,
                  language,
                },
                t,
              )}
              {' - '}
              <br />
              {formatDateMMMYYYY(
                {
                  date: item.endDate,
                  language,
                },
                t,
              )}
            </h6>
          )}
        </div>
        <div className="w-5/6 flex flex-col text-left mr-2">
          <h6
            className="font-semibold"
            style={{
              fontSize: fontSizeOptions['text-h3'] + fontSize,
            }}
          >
            <strong>{item.degree}</strong> {item.field}
          </h6>
          <span
            className="italic"
            style={{
              fontSize: fontSizeOptions['text-base'] + fontSize,
            }}
          >
            {item.institution}
            {item.gpa && `, GPA: ${item.gpa}`}
          </span>
          {item.summary && (
            <ReactMarkdown
              className={`markdown mt-2 ${classes.root}`}
              source={item.summary}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const EducationC = () => {
  const { data, heading: Heading } = useContext(PageContext);

  return safetyCheck(data.education) ? (
    <div>
      <RightHeading
        Heading={Heading}
        color={data.metadata.colors.primary}
        fontSize={data.metadata.margins.fontSize}
      >
        {data.education.heading}
      </RightHeading>
      <br />
      <div className="grid gap-4">
        {data.education.items.map((x) => (
          <EducationItem
            key={x.id}
            item={x}
            language={data.metadata.language}
            fontSize={data.metadata.margins.fontSize}
          />
        ))}
      </div>
    </div>
  ) : null;
};

export default memo(EducationC);
